<template>
  <div>
    <!-- 意见征集 -->
    <Board :index="2"></Board>
  </div>
</template>
<script>
import Board from '../components/Board';
export default {
  components: { Board },
};
</script>


// WEBPACK FOOTER //
// src/pages/CollectAdvice.vue